import { LineGraph } from "./LineGraph.js";

export default LineGraph;
